export default __webpack_public_path__ + "static/media/cloud-sun.729a95c3.svg";